import SignOut from '../pages/ExtraPages/SignOut';
import MyProfile from '../pages/Profile/MyProfile/MyProfile';
import Agencies from '../pages/Agencies/Agencies';
import Carriers from '../pages/Carriers/Carriers';
import GetQuotes from '../pages/GetQoute/GetQuotes';
import QuickQuote from '../pages/GetQoute/QuickQuote';
import QuickQuoteRates from '../pages/GetRate/QuickQuoteRates';
import DispatchShipment from '../pages/DispatchShipment/DispatchShipment';
import BookShipmentReview from '../pages/PickupShipment/PickupShipmentLTL';
import SignIn from '../pages/ExtraPages/SignIn';
import ResetPassword from '../pages/ExtraPages/ResetPassword';
import UpdatePassword from '../pages/ExtraPages/UpdatePassword';
import LockScreenComponent from '../pages/LockScreen/LockScreen';
import ConfirmationCode from '../pages/ExtraPages/ConfirmationCode';
import ViewShipment from '../pages/ViewShipment/ViewShipment';
import KanBan from '../pages/PickupShipment/KanBan';
import Locations from '../pages/Locations/ViewLocations';
import AddLocations from '../pages/Locations/AddLocations';
import BookShipmentReviewTL from '../pages/PickupShipment/PickupShipmentTL';
import AllUsers from '../pages/Users/AllUsers';
import Settings from '../pages/Settings/settings';
import ImportCsv from '../pages/ImportCsv/ImportCsv';
import CreateCarrier from '../pages/Carriers/CreateCarrier';
import CarrierManagerArea from '../components/CarrierManagerPage/CarrierManagerArea';
import BookParcelShipment from '../pages/PickupShipment/pickupShipmentParcel';
import AppRegisteration from '../pages/AppRegisteration/AppRegisteration';
import TrackShipmentModule from '../pages/TrackShipment/TrackShipmentModule';
import UnauthComponent from '../pages/UnauthComponent/UnauthComponent';
import ManageShipmentsTable from '../pages/Home/Layout2/ShipmentDetailsParentTable';
import Notifications from '../pages/Notifications/Notifications';
import ViewLogos from '../pages/ViewLogs/ViewLogos';
import NoModuleAssigned from '../pages/NoModuleAssigned/NoModuleAssigned';
import NotFoundPage from '../pages/404Component/Error404';
import InvoiceAudit from '../pages/InvoiceAudit/InvoiceAudit';
import FalconDashboard from '../pages/FalconDashboard';
import RoleManagement from '../pages/Users/RolesPermissions';
import TMSDashboard from '../pages/NewMUIDashboard/MUIDashboard';

const userRoutes = [
  { path: '/falcon-dashboard', component: FalconDashboard },
  { path: '/dashboard', component: TMSDashboard },
  { path: '/track-shipment', component: TrackShipmentModule },
  { path: '/user-profile', component: MyProfile },
  { path: '/manage-shipments', component: ManageShipmentsTable },
  { path: '/agencies', component: Agencies },
  { path: '/carriers', component: Carriers },
  { path: '/app-registration', component: AppRegisteration },
  { path: '/create-carrier', component: CreateCarrier },
  { path: '/view-locations', component: Locations },
  { path: '/add-locations', component: AddLocations },
  { path: '/get-quote', component: GetQuotes },
  { path: '/quick-quote', component: QuickQuote },
  { path: '/get-rates', component: QuickQuoteRates },
  { path: '/dispatch', component: DispatchShipment },
  { path: '/bookshipment', component: BookShipmentReview },
  { path: '/view-shipment', component: ViewShipment },
  { path: '/users', component: AllUsers },
  { path: '/roles', component: RoleManagement },
  { path: '/kanban', component: KanBan },
  { path: '/settings', component: Settings },
  { path: '/notifications', component: Notifications },
  { path: '/dispatchshipmentLTL', component: BookShipmentReview },
  { path: '/bookshipmentTL', component: BookShipmentReviewTL },
  { path: '/dispatchshipmentTL', component: BookShipmentReviewTL },
  { path: '/bookshipmentParcel', component: BookParcelShipment },
  { path: '/dispatchshipmentParcel', component: BookParcelShipment },
  { path: '/invoice-audit', component: InvoiceAudit },
  { path: '/import-csv', component: ImportCsv },
  { path: '/', component: ManageShipmentsTable },
  { path: '/not-authorized', component: UnauthComponent },
  { path: '/logs', component: ViewLogos },
  { path: '/404', component: NotFoundPage },
  { path: '/not-assigned', component: NoModuleAssigned }
];

const authRoutes = [
  { path: '/agency-signin', component: SignIn },
  { path: '/agency-resetpassword', component: ResetPassword },
  { path: '/update-password', component: UpdatePassword },
  { path: '/signout', component: SignOut },
  { path: '/agency-locked-screen', component: LockScreenComponent },
  { path: '/signup', component: SignIn },
  { path: '/confirmation', component: ConfirmationCode },
  { path: '/carrier-manager', component: CarrierManagerArea },
  { path: '/carrier-manager/requote', component: CarrierManagerArea },
  { path: '/carrier-manager/reschedule', component: CarrierManagerArea },
  { path: '/carrier-manager/acknowledge', component: CarrierManagerArea }
];

export { userRoutes, authRoutes };
